import React, { useEffect, useRef, useState } from 'react';
import { contentAPI } from '../services/api';
import { useLanguage } from '../context/LanguageContext';

const TrustedBy = () => {
  const scrollRef = useRef(null);
  const [companies, setCompanies] = useState([]);
  const { language } = useLanguage();

  // Fetch trusted companies from API
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const data = await contentAPI.getTrustedCompanies();
        setCompanies(data || []);
      } catch (error) {
        console.error('Failed to fetch trusted companies:', error);
        // Fallback data
        setCompanies([
          { id: "1", name: "VDAB" },
          { id: "2", name: "Colruyt Group" },
          { id: "3", name: "Brussels Airport" },
          { id: "4", name: "De Lijn" },
          { id: "5", name: "Equans Belux" },
          { id: "6", name: "Euroclear" },
          { id: "7", name: "Mondelez" },
        ]);
      }
    };
    fetchCompanies();
  }, []);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer || companies.length === 0) return;

    let animationId;
    let scrollPosition = 0;
    const scrollSpeed = 0.5;

    const scroll = () => {
      scrollPosition += scrollSpeed;
      if (scrollPosition >= scrollContainer.scrollWidth / 2) {
        scrollPosition = 0;
      }
      scrollContainer.scrollLeft = scrollPosition;
      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [companies]);

  if (companies.length === 0) {
    return null;
  }

  // Duplicate companies for infinite scroll effect
  const allCompanies = [...companies, ...companies];

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-gray-500 text-sm font-medium mb-8 uppercase tracking-wider">
          {language === 'nl' ? 'Vertrouwd door toonaangevende organisaties' : 'Trusted by Leading Organizations'}
        </p>
        
        {/* Scrolling Container */}
        <div
          ref={scrollRef}
          className="flex overflow-hidden gap-12"
          style={{ scrollBehavior: 'auto' }}
        >
          {allCompanies.map((company, index) => (
            <div
              key={`${company.id}-${index}`}
              className="flex-shrink-0 flex items-center justify-center h-12 px-6"
            >
              <span className="text-xl font-bold text-gray-400 whitespace-nowrap">
                {company.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
